<template>
  <el-avatar
    :size="size"
    :src="avatarUrl || null"
    class="employee-avatar"
  >
    <template v-if="!avatarUrl">{{ initials }}</template>
  </el-avatar>
</template>

<script>
export default {
  name: 'EmployeeAvatar',
  props: {
    name: {
      type: String,
      required: true
    },
    avatarUrl: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 23
    }
  },
  computed: {
    initials() {
      const parts = this.name.trim().split(' ')
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
      if (parts.length === 1) return parts[0][0].toUpperCase()
      return ''
    }
  }
}
</script>

<style scoped>
.employee-avatar {
  background-color: var(--cal-accent-strong) !important;
  color: var(--cal-text-inverse) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  flex-shrink: 0;
}
</style>
